export const SET_USER_DETAILS = 'SET_USER_DETAILS'
